import { render, staticRenderFns } from "./TaxiFollowOnJobsList.vue?vue&type=template&id=ba5fe0b6&"
import script from "./TaxiFollowOnJobsList.vue?vue&type=script&lang=js&"
export * from "./TaxiFollowOnJobsList.vue?vue&type=script&lang=js&"
import style0 from "./TaxiFollowOnJobsList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports